import { Component, DestroyRef, inject, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';

import { LegacyHealthCheckService, LottieFilesService, StorageService } from '@coin/shared/core/data-access';
import { ContentLanguage, StorageKey } from '@coin/shared/core/util-enums';
import { TranslateService } from '@ngx-translate/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UpdateNotificationsService } from '@coin/shared/core/util-helpers';
import { HeaderComponent } from './static/header/header.component';
import { TranslationViewerBannerComponent } from '@coin/shared/auth/feature';

export let INJECTOR_INSTANCE: Injector;

@Component({
  selector: 'admin-app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HeaderComponent, RouterOutlet, TranslationViewerBannerComponent]
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly translate = inject(TranslateService);
  private readonly lottieFilesService = inject(LottieFilesService);
  private readonly injector = inject(Injector);
  private readonly healthCheckService = inject(LegacyHealthCheckService);
  private readonly storageService = inject(StorageService);
  private readonly destroyRef = inject(DestroyRef);

  previousPath: string;
  constructor() {
    inject(UpdateNotificationsService).checkForUpdates();
    this.checkBackendStatus();
    this.initializeApp();
    INJECTOR_INSTANCE = this.injector;
  }

  checkBackendStatus(): void {
    this.healthCheckService
      .ping()
      .pipe(
        catchError(err => {
          this.router.navigate(['fallback'], { skipLocationChange: true });
          return throwError(err);
        })
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  async ngOnInit(): Promise<void> {
    const lang = this.storageService.get(StorageKey.LANGUAGE);
    if (lang) {
      this.translate.use(lang);
    } else {
      this.translate.use(ContentLanguage.ENGLISH);
    }
    const preLoadFiles = ['add', 'edit', 'delete', 'add-white'];
    for (const itm of preLoadFiles) {
      this.lottieFilesService
        .getLottieJson(itm)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(aw => {
          this.lottieFilesService.setLottieFile(itm, aw);
        });
    }
  }

  initializeApp(): void {
    this.translate.setDefaultLang(ContentLanguage.ENGLISH);
  }
}
